import * as React from "react";

import { DEFAULT_DEDUCTIBLE_CARAVAN } from "../constants";

import { StyledAlert } from "App/global-style";
import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { Select } from "Components/Form/Select";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { CaravanCoverage } from "Store/interfaces/products/coverage";
import { TextLanguage } from "Store/texts/interfaces";
import { replacePlaceholder } from "Utils/replacePlaceholder";
import type { FormikProps } from "formik";
import { getDeductibles } from "../../vehicleUtils";
import { CaravanTexts } from "../interface";
import { CaravanProductPriceFormValues } from "./interfaces";

interface Props {
  formProps: FormikProps<CaravanProductPriceFormValues>;
  coverages: CoveragePriceCalculation[];
  texts: CaravanTexts["formText"]["checkPrice"];
  lang: TextLanguage;
}

export const Deductible = (props: Props): React.ReactElement => {
  const { formProps, coverages, texts, lang } = props;

  React.useEffect(() => {
    if (
      formProps.values.coverage !== CaravanCoverage.CARAVAN_FIRE_AND_THEFT &&
      Number.isNaN(parseInt(formProps.values.deductible))
    ) {
      formProps.setFieldValue("deductible", DEFAULT_DEDUCTIBLE_CARAVAN);
    }
  }, [formProps.values.coverage]);

  if (formProps.values.coverage === CaravanCoverage.CARAVAN_FIRE_AND_THEFT) {
    return (
      <StyledAlert
        alertId="deductible"
        title={texts.deductible.defaultDeductible.title[lang]}
        fluid
      >
        {replacePlaceholder(
          texts.deductible.defaultDeductible.description[lang],
          { deductible: DEFAULT_DEDUCTIBLE_CARAVAN },
        )}
      </StyledAlert>
    );
  }

  const deductibleOptions = getDeductibles(
    INSURANCE_NAME_VALUE.CARAVAN,
    formProps.values.coverage,
    coverages,
  );

  return (
    <Select
      id="deductible"
      name="deductible"
      label={texts.deductible.label[lang]}
      hint={texts.deductible.hint?.[lang]}
      options={deductibleOptions}
      large
    />
  );
};
